<!-- 此component用來左下Hint的顯示 -->
<template>
  <div v-show="display">
  <transition name="fade">
      <div class="helper" v-if="this.$store.state.showHint">
        <div class="text">{{message}}</div>
        <div @click="$emit('close')" class="close">x</div>
      </div>
  </transition>
  </div>
</template>

<script>
  export default {
    name: 'flash-view',
    props: {
      message:  String,
      display: false,
    },
    data() {
      return {
        
      };
    },
    created() {

    },
    methods: {

    },
    watch: {
      /*
      message: function(newVal, oldVal) {
        setTimeout(()=>{
          //this.tempMessage = '';
          this.$store.state.isShowHint = false;
        }, 3000);
      } 
      */
    }
  };
</script>
<style scoped lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.helper{
    background: #323232;
    border-radius: 1px;
    min-width: 240px;
    width: auto;
    height: 50px;
    font-size: 14px;
    margin-left:20px;
    z-index:2200;
    position: fixed;
    bottom: 30px;
    float: left;
}
.helper .text{
  float: left;
  font-size: 14px;
  color: #f1f1f1;
  margin-left: 20px;
  vertical-align: middle;
  line-height: 50px;
}
.helper .close {
    color: #f1f1f1;
    cursor: pointer;
    font-size: 16px;
    float: right;
    margin-right: 10px;
    padding-left: 20px;
    vertical-align: middle;
    line-height: 50px;
}
</style>



// WEBPACK FOOTER //
// Hint.vue?23272dd2